class MemberTodosFilter
  constructor: ->
    @viewBy = $('.member-todos[data-view-by]').data('view-by')
    @_updateBoxes()

  _updateBoxes: ->
    tower.memberTodosInit()

    if @viewBy == 'gtd_box'
      $('#page-member .box').each ->
        $(@).toggleClass 'empty', !$(@).find('.expanded-todo').length
    else if @viewBy == 'created_at'
      @_sort 'createdAt'
    else if @viewBy == 'due_at'
      @_sort 'dueAt'

  _sort: (key) ->
    $todos = $('.expanded-todo')
    $todos.sort (row1, row2) ->
      t1 = $.trim row1.dataset[key]
      t2 = $.trim row2.dataset[key]
      t1 > t2
    $('.todos-uncompleted').append $todos


tower.memberTodosFilter = ->
  new MemberTodosFilter

tower.memberTodosInit = ->
  $init = $('.init-todo-completed')
  if $('.member-todos[data-view-by]').data('view-by') == 'gtd_box'
    $init.hide()
  else
    $init.toggle !$('.expanded-todo').length
